"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Music = function Music(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 40 40",
    width: "40",
    height: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,12c0.001-4.295-3.034-7.992-7.247-8.829c-0.08-0.016-0.163,0.008-0.222,0.065c-0.059,0.057-0.086,0.138-0.074,0.219 C16.486,3.635,16.5,3.817,16.5,4v5.616c0,0.109,0.071,0.205,0.175,0.238c1.185,0.373,1.843,1.637,1.47,2.822 c-0.221,0.7-0.769,1.249-1.47,1.47c-0.104,0.033-0.175,0.129-0.175,0.238V20c0,0.183-0.014,0.365-0.043,0.545 c-0.022,0.136,0.071,0.265,0.207,0.287c0.031,0.005,0.062,0.004,0.093-0.003C20.968,19.991,24.001,16.294,24,12z M15,20V4 c0-1.105-0.895-2-2-2H2C0.895,2,0,2.895,0,4v16c0,1.105,0.895,2,2,2h11C14.105,22,15,21.105,15,20z M4.25,13.3h0.028 c0.059,0.001,0.115-0.022,0.157-0.063C4.477,13.196,4.5,13.14,4.5,13.081v-2.956C4.499,9.281,5.099,8.556,5.928,8.4l3.409-1.1 c0.537-0.127,1.103,0.002,1.531,0.35C11.27,7.983,11.502,8.478,11.5,9v4.046c0.002,0.966-0.779,1.752-1.746,1.754 S8.002,14.02,8,13.054C7.998,12.088,8.78,11.302,9.746,11.3c0.001,0,0.003,0,0.004,0h0.028c0.059,0.001,0.115-0.022,0.157-0.063 c0.043-0.042,0.066-0.1,0.065-0.16V9c0-0.138-0.112-0.25-0.25-0.25c-0.015,0-0.03,0.001-0.045,0.004L6.3,9.856 C6.09,9.901,6,10.005,6,10.125v4.921c0.002,0.966-0.779,1.752-1.746,1.754C3.288,16.802,2.502,16.02,2.5,15.054 C2.498,14.088,3.28,13.302,4.246,13.3C4.247,13.3,4.249,13.3,4.25,13.3z",
    stroke: "none",
    fill: fill,
    strokeWidth: "0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Music.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Music.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Music;